<template>
  <a-modal
    :open="open"
    title="Informativo sobre suspensión"
    @cancel="handleCancel"
    width="700px"
    class="strategy__email-modal"
  >
    <div class="suspension">
      <h2>⚠️ Suspensión de envíos de correos masivos ⚠️</h2>
      <div class="info">
        <p>
          Tu cuenta fue suspendida el 20 de noviembre del 2023 debido a las altas tasas de rebotes
          duros que se han detectado y/o quejas de spam. Es posible que algunos de tus contactos se
          hayan quedado obsoletos o no hayan aceptado recibir las comunicaciones de tu marca. Esto
          afecta negativamente la capacidad de tu marca para llegar a sus destinatarios principales.
          <a-button type="link">Click aquí</a-button> para conocer más sobre las suspensiones de
          correos masivos.
        </p>
        <h3>N° estimado de correos con problemas</h3>
        <span>4536</span>
      </div>
    </div>
    <template #footer>
      <div class="modal__footer">
        <div class="footer__update">
          <a-button @click="handleCancel">Cancelar</a-button>
        </div>
        <div>
          <a-button type="primary" @click="handleSolution">Solucionar Suspensión</a-button>
        </div>
      </div>
    </template>
  </a-modal>
  <EmailAppealSuspension v-model:open="openAppealModal" :customChannelId="customChannelId" />
</template>
<script lang="ts" setup>
import { ref, watch } from "vue";
import EmailAppealSuspension from "@/app/strategies/components/modals/EmailAppealSuspension.vue";

const props = defineProps<{ open: boolean; customChannelId: number }>();

const openAppealModal = ref<boolean>(false);

const emit = defineEmits<{ "update:open": [open: boolean] }>();

const handleCancel = (e: MouseEvent) => {
  console.log(e);
  emit("update:open", false);
};

const handleSolution = () => {
  emit("update:open", false);
  openAppealModal.value = true;
};
watch(
  () => props.customChannelId,
  (newValue, oldValue) => {
    console.log("Updated", newValue);
  }
);
</script>
<style lang="sass" scoped>
h2
  text-align: center
  margin-bottom: 20px
.strategy__email-modal
  .modal__footer
    display: flex
    gap: 10px
    justify-content: flex-end
</style>
<style>
.strategy__email-modal .suspension {
  padding: 20px;
}
.strategy__email-modal .suspension .info {
  background: #f0f0f0;
  padding: 32px;
  border-radius: 4px;
}
</style>
